import APIService from '@/api';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import { getSignUpUrlRoutes } from '@/views/Onboarding/helpers';
import { isExternalOauthSessionOnline } from '../router-utils';

class BusinessOnboardingRedirect {
  constructor(
    private readonly to: MiddlewareRoute,
    private readonly from: MiddlewareRoute,
    private readonly next: MiddlewareCallback
  ) {}

  execute() {
    const { name } = this.to;

    const prefixSignup = getSignUpUrlRoutes();

    if (name === 'bo-your-digital-coin' && !isExternalOauthSessionOnline()) {
      this.next(prefixSignup.YOUR_BUSINESS);

      return;
    }

    if (APIService.token && name === 'bo-your-account') {
      this.next(prefixSignup.YOUR_BUSINESS);

      return;
    }

    this.next();
  }
}

export class HandleBusinessOnboardingRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute) {
    return to.matched.some(route => route.name === 'business-onboarding');
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    const instance = new BusinessOnboardingRedirect(to, from, next);
    instance.execute();
  }
}
